import React, { PureComponent } from 'react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'

class ChooseIndustryModal extends PureComponent {
    render() {
        const {
            industries, show, onClose, onSelect,
        } = this.props

        return (
            <Modal id="industry-modal" show={show} onClose={() => { onClose(false) }}>
                <div className="uc-modal__header">
                    <h2>{i18n.t('home.modal.chooseIndustry')}</h2>
                    <p className="uc-modal__desc">
                        {i18n.t('home.modal.chooseIndustry.desc')}
                    </p>
                </div>
                <div className="industry-btn-wrapper">
                    {industries?.map(({ code: industryCode, name }) => (
                        <Button
                            label={name}
                            cssClass="primary regular industry-btn"
                            onClick={() => { onSelect(industryCode, 0) }}
                        >
                            <i className="fa-light fa-arrow-right" />
                        </Button>
                    ))}
                </div>
            </Modal>
        )
    }
}

export default ChooseIndustryModal
